import { CdkMenuModule } from '@angular/cdk/menu';
import { CommonModule } from '@angular/common';
import { Component, inject, input } from '@angular/core';
import { BaseConfig, Button, IconButton, Menu, MenuOption } from '@client';
import { AdminStore } from 'apps/admin/src/stores/admin.store';

@Component({
  selector: 'app-top-bar',
  templateUrl: './top-bar.component.html',
  styleUrls: ['./top-bar.component.scss'],
  standalone: true,
  imports: [CommonModule, IconButton, Button, Menu, MenuOption, CdkMenuModule],
})
export class TopBar extends BaseConfig {
  header = input.required<string>();
  description = input<string>();
  isScrolled = input<boolean>(false);
  adminStore = inject(AdminStore);
  admin = this.adminStore.admin;

  toggleTheme() {
    this.themeStore.setTheme(
      this.themeStore.theme() === 'dark' ? 'light' : 'dark',
    );
  }
}
